import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import type { DatasetBriefDto } from '@/api';
import src from '@/utils/filters/src';

interface TableIconProps {
  dataset: DatasetBriefDto
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Table-Icon',
  props: {
  dataset: null
},
  setup(__props) {


const image = _computed(() => src(__props.dataset.datasourceType, 'datasources'));
const alt = _computed(() => __props.dataset.datasourceType);
const to = _computed(() => ({
    name: 'data-catalog.asset.overview',
    params: { urn: __props.dataset?.urn },
  }));

return { __sfc: true,image, alt, to, _computed, src }
}

})